import React, { useState } from 'react';
import { Box, Button, CircularProgress, Grid, Typography } from '@mui/material';
import { AuthPageStyles } from '../../authentication/styles';
import { ReactComponent as ReAttemptIcon } from '../images/reAttempt.svg';
import { useTranslation } from 'react-i18next';
import { logoutUser } from '../../common/utils/logoutUser';
import { useNavigate } from 'react-router-dom';
import { routeMappings } from '../../constants';
import ReAttemptStyles from '../../common/styles/reAttempt';
import { StaticPageIconStyles } from '../../common/styles/staticPageIcon';
import { useAppSelector } from '../../store/hook';
import { getExperienceInitCookie } from '../../common/utils/experienceInitCookie';
import { getCookie } from '../../common/utils/cookies';
import { WCAGStrandardStyles } from '../../common/styles/WCAGStandardStyles';
import PaperContainer from '../../authSimplified/components/PaperContainer';

export const ReAttemptPage = (): React.JSX.Element => {
  const { t } = useTranslation();
  const { settings } = useAppSelector((state) => state.template);
  const candidate = useAppSelector((state) => state.candidate);
  const { isICPEnabled } = useAppSelector((state) => state.headerDetails);
  const { classes } = AuthPageStyles({ isICPEnabled: isICPEnabled });
  const { classes: reAttemptClasses } = ReAttemptStyles(settings);
  const { classes: StaticPageIconClasses } = StaticPageIconStyles();
  const tcPlusFlow = getCookie('TcPlusFlag') === '1';
  const { classes: WCAGClasses } = WCAGStrandardStyles();
  const navigate = useNavigate();
  const expCookie = getExperienceInitCookie();

  const [loading, setLoading] = useState<boolean>(false);

  const signOut = async (): Promise<void> => {
    setLoading(true);
    const res = await logoutUser(candidate);
    if (res.data && res.data.Success) {
      if (expCookie?.autoLogin && tcPlusFlow) {
        navigate(routeMappings['AUTH_LOGOUT']);
      } else {
        navigate(routeMappings['LOGIN']);
      }
    }
    setLoading(true);
  };

  return (
    <PaperContainer className={classes.paper} variant="medium">
      <Box textAlign="center">
        <Box>
          <ReAttemptIcon width="120px" height="120px" className={StaticPageIconClasses.staticPageIcon} />
          <Typography
            role="heading"
            aria-level={1}
            className={`${reAttemptClasses.reAttemptHeading} ${WCAGClasses.h2}`}>
            {t('reAttemptHeading')}
          </Typography>
        </Box>
        <Box>
          <Box className={reAttemptClasses.reAttemptText}>
            <Typography variant="body1">{t('reAttemptMessage1')}</Typography>
          </Box>
          <Box className={reAttemptClasses.reAttemptText}>
            <Typography variant="body1">{t('reAttemptMessage2')}</Typography>
          </Box>
        </Box>
      </Box>
      {/** button for sign in */}
      <Grid item xs={12}>
        <Box width="100%" textAlign="center">
          <Button
            type="submit"
            variant="outlined"
            color="primary"
            disabled={loading}
            aria-hidden={loading}
            aria-disabled="false"
            onClick={signOut}>
            <div>{t('signout')}</div>
            {loading && <CircularProgress size={25} className={classes.buttonProgress} />}
          </Button>
        </Box>
      </Grid>
    </PaperContainer>
  );
};
